import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { listDayforceJobsIssues } from 'api/admin/dayforce/listDayforceJobsIssues'
import { dayforceKeys } from './keys'

export const useDayforceJobsIssuesQuery = (
  request: Parameters<typeof listDayforceJobsIssues>[0]
) => {
  return useQuery({
    queryKey: dayforceKeys.jobsIssuesList(request),
    queryFn: () => listDayforceJobsIssues(request),
    placeholderData: keepPreviousData,
  })
}
